module.exports = __webpack_public_path__ + "static/media/LowCost_02.725d0217.svg";